<template>
  <!-- Main navbar -->
  <div class="navbar navbar-default header-highlight">
    <div class="navbar-header">
      <p
        class="navbar-brand hidden-xs"
        style="padding-top: 8px"
      >
        <img
          src="../../assets/images/black_shipzone.png"
          class="img-responsive"
          style="height: 40px; width: 40px; float: left"
          alt=""
        />
        <span style="float: left; color: #333; padding: 13px 0px 10px 20px; font-size: 18px; font-weight: 500">ShipZone</span>
      </p>
      <ul class="nav navbar-nav visible-xs-block">
        <li style="padding-top: 10px; padding-right: 13px; ">
          <img
            src="../../assets/images/black_shipzone.png"
            class="img-responsive"
            style="height: 40px; width: 40px;"
            alt=""
          />
        </li>
        <li style="padding-top: 18px; padding-right: 13px; color: #000; font-size: 16px; font-weight: 500">
          ShipZone
        </li>

        <li v-if="!loggedInUserData.is_staff">
          <h5
            style="color: white; padding-top: 5px"
            v-if="loggedInUserData.credit === null"
          >
            Credit: $0
          </h5>
          <h5
            style="color: white; padding-top: 5px"
            v-else
          >
            Credit: ${{ loggedInUserData.credit }}
          </h5>
        </li>
        <li>
          <a
            data-toggle="collapse"
            data-target="#navbar-mobile"
          ><i class="material-icons">device_hub</i></a>
        </li>
        <!-- <li>
          <a class="sidebar-mobile-main-toggle"><i
              class="fa fa-align-justify"
              style="font-size: 20px;  padding-top: 4px"
            ></i></a>
        </li> -->
        <li>
          <a
            @click="showSidebar = !showSidebar"
            style="font-size: 20px;  padding-top: 18px"
          >
            <i class="fa fa-align-justify" />
          </a>
        </li>
      </ul>
    </div>

    <div
      class="navbar-collapse collapse"
      id="navbar-mobile"
    >
      <ul class="nav navbar-nav">
        <li>
          <a
            data-toggle="collapse"
            style="padding-top: 20px"
            class="sidebar-control sidebar-main-toggle hidden-xs"
            @click="$emit('toggle-sidebar')"
          ><i
              class="fa fa-align-justify"
              style="font-size: 20px"
            ></i></a>
        </li>
      </ul>

      <div class="navbar-right">
        <!-- New order Notification -->
        <ul
          class="nav navbar-nav"
          v-if="false"
        >
          <li class="dropdown">
            <a
              class="dropdown-toggle"
              data-toggle="dropdown"
              id="notification-icon"
              style="text-align: center"
            >
              <i
                class="fa fa-bell"
                style="font-size: 20px; padding-top: 5px; position: relative"
              >
                <span
                  v-if="count !== 0"
                  class="status-mark bg-danger-400 media-badge"
                  style="border: 5px; background-color: #f44; position: absolute; top: 3px; right: -5px"
                ></span>
              </i>
            </a>

            <div class="dropdown-menu dropdown-content">
              <div class="dropdown-content-heading">
                Notifications
              </div>

              <ul class="media-list dropdown-content-body width-300">
                <li
                  class="media"
                  v-for="n in apiResults"
                  :key="n.order_notification_id"
                >
                  <div class="media-body">
                    <span
                      v-if="n.is_open == 0 ? (count = 1) : ''"
                      class="status-mark bg-danger-600 media-badge"
                      style="border: 5px; margin-top: 2px; left: -10px"
                    ></span>
                    <router-link
                      :to="'/new-order?order=' + n.order_id"
                      tag="a"
                      active-class="active"
                    >
                      <a
                        style="color: #555555"
                        @click="openNotification(n.order_notification_id, 'notification-icon')"
                      >{{ n.full_name }} requested a new order
                        <div
                          class="media-annotation"
                          style="color: #555555"
                        >
                          {{ n.created_at }}
                        </div>
                      </a>
                    </router-link>
                  </div>
                </li>
              </ul>

              <div class="dropdown-content-footer">
                <div class="col-sm-6">
                  <a @click="moreResult()">View more</a>
                </div>
                <div class="col-sm-6">
                  <a @click="lesResult()">View less</a>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!-- Warehouse passed Notification -->
        <ul
          class="nav navbar-nav"
          v-if="loggedInUserData.is_staff"
        >
          <li class="dropdown">
            <a
              class="dropdown-toggle"
              data-toggle="dropdown"
              id="notification-icon-2"
              style="text-align: center"
            >
              <i
                class="fa fa-bell"
                style="font-size: 20px; padding-top: 5px; position: relative"
              >
                <span
                  v-if="apiResults2.length > 0"
                  class="status-mark bg-danger-400 media-badge"
                  style="border: 5px; background-color: #f44; position: absolute; top: 3px; right: -5px"
                ></span>
              </i>
            </a>

            <div class="dropdown-menu dropdown-content">
              <div class="dropdown-content-heading">
                Warehouse date passed orders
              </div>

              <ul class="media-list dropdown-content-body width-300">
                <li
                  class="media"
                  v-for="n in apiResults2"
                  :key="n.order_notification_id"
                  :id="`wh-noti-${n.order_notification_id}`"
                >
                  <div class="media-body">
                    #{{ n.theOrderId }}
                    <span style="margin-left: 10px">Wh. Date: </span>
                    <strong>{{ n.warehouse_date }}</strong>
                    <i
                      style="margin-left: 20px; font-size: 16px; cursor: pointer"
                      @click="hideNotification(n.order_notification_id)"
                      class="fa fa-times error--text"
                    />
                  </div>
                </li>
              </ul>

              <div class="dropdown-content-footer">
                <div class="col-sm-6">
                  <a @click="moreResult2()">View more</a>
                </div>
                <div class="col-sm-6">
                  <a @click="lesResult2()">View less</a>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <p
          style="padding-top: 20px; font-size: 17px; color: black"
          class="navbar-text"
          v-if="!loggedInUserData.is_staff"
        >
          <b v-if="loggedInUserData.credit === null">Credit: $0</b>
          <b v-else>Credit: ${{ loggedInUserData.credit }}</b>
        </p>
        <p
          style="padding-top: 20px;"
          class="navbar-text"
        >
          <span
            class="label bg-success"
            style="font-size: 11px"
          >
            <span class="pr-1"><i class="fa fa-user"></i></span>
            {{ loggedInUserData.full_name }}
          </span>
        </p>

        <!-- <ul class="nav navbar-nav">
                    <li style="padding-top: 3px"> -->
        <v-btn
          flat
          style="height:auto; color:#FF8F00; padding-top: 15px"
          @click="logout()"
        ><i class="material-icons">power_settings_new</i>Logout</v-btn>
        <!-- </li>
                </ul> -->
      </div>
    </div>

    <!-- boya amam danawa chwnka la mobile bashakan na akranawa garna peshtr am code a lera nabw  -->
    <div
      v-if="showSidebar && !loggedInUserData.is_staff"
      id="mobile-sidebar-list"
    >
      <div class="sidebar-category sidebar-category-visible sidebar-list">
        <div class="category-content no-padding">
          <ul class="navigation navigation-main navigation-accordion">
            <router-link
              class="sidebar-mobile-main-toggle"
              to="/make-new-ship-only"
              tag="li"
              active-class="active"
            ><a>
                <i class="material-icons">add</i>
                <span>Ship Only</span></a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              to="/make-new-order"
              tag="li"
              active-class="active"
            ><a>
                <i class="material-icons">add_box</i>
                <span>New Order</span></a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              to="/my-order"
              tag="li"
              active-class="active"
            ><a>
                <i class="material-icons">filter_none</i>
                <span>Orders</span></a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              to="/my-order-cases"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-folder-open"
                />
                Order Cases
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              to="/archived-order"
              tag="li"
              active-class="active"
            ><a><i class="material-icons">archive</i>Archived Orders</a></router-link>
            <li>
              <a href=""><i class="material-icons">assignment</i><span>Invoices</span></a>
              <ul>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/customer-invoice"
                  tag="li"
                  active-class="active"
                ><a>Order Invoices</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/customer-order-invoice"
                  tag="li"
                  active-class="active"
                ><a>Shipping Invoices</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/customer-credit-invoice"
                  tag="li"
                  active-class="active"
                ><a>Credit Invoices</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/customer-partial-refund"
                  tag="li"
                  active-class="active"
                ><a>Partial Refund Invoices</a></router-link>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- /main navbar -->
</template>

<script>
import axios from 'axios'

export default {
  props: ['loggedInUserData'],

  created() {
    this.getResults()
    this.storeWarehousePassed()

    // if (this.loggedInUserData.is_staff) {
    //   setInterval(() => {
    //     this.getResults()
    //   }, 10000)
    // }
  },

  data() {
    return {
      url: 'api/order_notification',
      openNotificationURL: 'api/open_notification',
      apiResults: [],
      showSidebar: false,
      tableData: {
        per_page: 10
      },
      count: 0,
      apiResults2: [],
      tableData2: {
        per_page: 10
      },
      count2: 0
    }
  },

  watch: {
    $route() {
      this.showSidebar = false
    }
  },

  methods: {
    storeWarehousePassed() {
      let token = localStorage.getItem('access_token')

      if (this.loggedInUserData.is_staff) {
        axios
          .get('/api/store_warehouse_passed', { headers: { Authorization: 'Bearer ' + token } })
          .then(() => {
            this.getWarehousePassed()
          })
      }
    },

    getWarehousePassed() {
      let token = localStorage.getItem('access_token')

      axios
        .get('/api/get_warehouse_passed', {
          params: this.tableData2,
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          let data = response.data
          this.apiResults2 = data.data.data
        })
    },

    getResults(url = this.url) {
      this.count = 0
      let token = localStorage.getItem('access_token')
      axios
        .get(url, {
          params: this.tableData,
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          if (!response.data.message) {
            let data = response.data
            this.apiResults = data.data.data
          }
        })
        .catch((errors) => { })
    },

    logout() {
      let token = localStorage.getItem('access_token')

      axios
        .post('api/logout', '', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          localStorage.clear()
          window.location.href = '/'
        })
    },

    openNotification(id, notiId) {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.openNotificationURL + '/' + id, '', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => { })
        .then(() => {
          $(`#${notiId}`).click()
        })
    },

    hideNotification(id) {
      let token = localStorage.getItem('access_token')

      axios
        .get(`/api/hide_notification/${id}`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          const noti = document.querySelector(`#wh-noti-${id}`)
          noti.classList.add('hide-animation')
          setTimeout(() => {
            noti.classList.remove('hide-animation')
            this.getWarehousePassed()
          }, 500)
        })
    },

    moreResult() {
      this.tableData.per_page = this.tableData.per_page + 5
      this.getResults()
    },

    lesResult() {
      if (this.tableData.per_page !== 10) {
        this.tableData.per_page = 10
        this.getResults()
      }
    },

    moreResult2() {
      this.tableData2.per_page += 5
      this.getWarehousePassed()
    },

    lesResult2() {
      if (this.tableData2.per_page !== 10) {
        this.tableData2.per_page = 10
        this.getWarehousePassed()
      }
    }
  }
}
</script>

<style>
#mobile-sidebar-list {
  background-image: radial-gradient(
    circle 919px at 1.7% 6.1%,
    rgba(41, 58, 76, 1) 0%,
    rgba(40, 171, 226, 1) 100.2%
  ) !important;
  color: #fafafa;
  -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
}
.disabled {
  pointer-events: none;
  color: gray;
}

.hide-animation {
  animation: linear;
  animation-name: rightLeft;
  animation-duration: 0.5s;
}

@keyframes rightLeft {
  0% {
    right: 0;
  }
  100% {
    right: calc(100% - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue